import { IJsonSerializable } from "../util/interfaces";
import { OpOperator } from "../core/op-operator";
import { OpDBScriptParam } from "./op-db-script-param";
import { TypeHelper } from "../../helpers/type-helper";

export class OpDBScript implements IJsonSerializable {

    // Members

    public idDBScript: number
    public name: string
    public description: string
    public content: string
    public author: OpOperator
    public arguments: OpDBScriptParam[]

    // Members End

    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End

    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.idDBScript = opObj.I
                this.name = opObj.N
                this.description = opObj.D
                this.content = opObj.C
                this.author = opObj.A ? new OpOperator(opObj.A) : null
                if (opObj.AR) {
                    this.arguments = opObj.AR.map((data: OpDBScriptParam) => new OpDBScriptParam(data))
                } else {
                    opObj.AR = null
                }
            } else {
                this.idDBScript = opObj.IdDBScript
                this.name = opObj.Name
                this.description = opObj.Description
                this.content = opObj.Content
                this.author = opObj.Author ? new OpOperator(opObj.Author) : null
                if (opObj.Arguments) {
                    this.arguments = opObj.Arguments.map((data: any) => new OpDBScriptParam(data))
                } else {
                    this.arguments = null
                }
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                I: this.idDBScript,
                N: this.name,
                D: this.description,
                C: this.content,
                A: this.author ? this.author.toJSON(compressed) : null,
                AR: this.arguments ? this.arguments.map((data: OpDBScriptParam) => data.toJSON(compressed)) : null
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }
            return {
                IdDBScript: this.idDBScript,
                Name: this.name,
                Description: this.description,
                Content: this.content,
                Author: this.author ? this.author.toJSON(compressed) : null,
                Arguments: this.arguments ? this.arguments.map((data: OpDBScriptParam) => data.toJSON(compressed)) : null,
            }
        }
        // IJsonSerializable Implementation End
    }


